export default "__VITE_ASSET__CI2NsJU7__"